import React, { Component } from 'react'
import Image from 'components/common/ImageLoader'
import EmailIcon from 'assets/envelope.svg'

const ResetPassword = (pros) => {
    return (
        <div className="mt-40 ">
            <div className="my-10 flex flex-wrap items-center justify-center">
                <Image width={100} height={100} src={EmailIcon} />
            </div>
            <div className="flex flex-wrap items-center justify-center">
                <div class=" bg-gray-200 rounded-lg p-8 flex flex-col w-128">
                    <h2 class="text-gray-900 text-lg font-medium title-font mb-5">
                        Request for new password
                    </h2>
                    <input
                        class="bg-white rounded border border-gray-400 focus:outline-none focus:border-primary-500 text-base px-4 py-2 mb-4"
                        placeholder="Please enter your email"
                        type="email"
                    />
                    <button class="text-white bg-primary-500 border-0 py-2 px-8 focus:outline-none hover:bg-primary-500 rounded text-lg">
                        Send Email
                    </button>
                    <p class="text-xs text-gray-500 mt-3">
                        If you are experiencing any difficulty, please contact{' '}
                        <a
                            className="text-primary-500 font-light"
                            href="mailto:hello@intrigue.io"
                        >
                            hello@intrigue.io
                        </a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword
